import { SCOPE } from "@kamae-apps/shared/Types/Scope"

export function scopeToString(scope: SCOPE) {
  switch (scope) {
    case SCOPE.COMPANY_ADMIN:
      return "Admin Entreprise"
    case SCOPE.USER:
      return "User"
    case SCOPE.SUPER_ADMIN:
      return "Admin Kamaé"
  }
}

export function stringToScope(str: string): SCOPE {
  return (SCOPE[str as keyof typeof SCOPE] as SCOPE) || SCOPE.USER
}
